import axios from "services/auth/jwt/config";

const reportCardService = {
  getAll: page =>
    axios.get("/reportcard/getall", { params: { page, limit: 10 } }),
  getById: id => axios.get(`/reportcard/getbyid/${id}`),
  create: data => axios.post("/reportcard/create", data),
  update: (id, data) => axios.patch(`/reportcard/update/${id}`, data),
  remove: id => axios.delete(`/reportcard/delete/${id}`)
};

export default reportCardService;
